import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(() => ({
  textAlign: 'center',
  height: 80,
  lineHeight: '80px',
  marginTop: '18px'
}));

export default function NoStatements() {
  return (

  <Item elevation={1}>
      <p className='text-[16px] font-medium'>No Statements to show</p>
  </Item>

  );
}